import {
  ElementRef,
  Injector,
  Component,
  OnInit,
  Input,
  HostListener
} from "@angular/core";
import { BaseComponent } from "../../base.component";
import { get, find } from "lodash";
@Component({
  selector: "provider-info",
  template: `
    <table *ngIf="showProvidor">
      <tr>
        <td
          *ngIf="
            selectedOption.imgUrl.indexOf('Progressive') === -1
          "
          class="logo"
        >
          <img class="prog-home-logo" [src]="control.attributes.proglogo" />
          <img class="carrier-logo" [src]="selectedOption.imgUrl" />
        </td>
        <td
          *ngIf="
            selectedOption.imgUrl.indexOf('Progressive') !== -1
          "
          class="logo"
        >
          <img class="prog-home-logo" [src]="selectedOption.imgUrl" />
        </td>
        <td class="more desktop">
          <button
            class="caret-button"
            [disabled]="control.disabled"
            [ngClass]="{ open: control.open }"
            (click)="control.open = !control.open"
            [attr.aria-expanded]="control.open || false"
            gtm-handler
            events="click"
            handlerType="button"
            label="{{
              control.open
            }} ? 'Provider_Info_Show' : 'Provider_Info_Hide'"
            action="ButtonClick"
          >
            <i class="icon icon-caret"></i>
          </button>
        </td>
      </tr>
      <tr>
        <td class="text">
          <p
            *ngIf="!control.open"
            [innerHtml]="selectedOption.collapsedText"
          ></p>
          <p *ngIf="control.open" [innerHtml]="selectedOption.expandedText"></p>
        </td>
        <td class="more mobile">
          <button
            class="caret-button"
            [disabled]="control.disabled"
            [ngClass]="{ open: control.open }"
            (click)="control.open = !control.open"
            [attr.aria-expanded]="control.open || false"
            gtm-handler
            events="click"
            handlerType="button"
            label="{{
              control.open
            }} ? 'Provider_Info_Show' : 'Provider_Info_Hide'"
            action="ButtonClick"
          >
            <i class="icon icon-caret"></i>
          </button>
        </td>
      </tr>
    </table>
  `,
  styleUrls: ["./providor-info.component.scss"]
})
export class ProviderInfoComponent extends BaseComponent implements OnInit {
  selectedOption;
  showProvidor: boolean;
  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit() {
    this.getSelection();
    this.observablesService.insurerSelected.subscribe(() => {
      this.getSelection();
    });
  }

  getSelection() {
    let selected = this.storeService.getValue(
      "CarrierInformation",
      this.context
    );

    let val = find(this.control.attributes.options, {
      name: selected.name
    });
    this.showProvidor = val && !selected.hasPackage;
    this.elementRef.nativeElement.className = this.showProvidor ? "" : "hide";
    if (val !== undefined && val !== false) {
      this.selectedOption = val;
    }
  }
}
